import React from 'react';
import "./style.scss";
import { FormattedMessage } from 'react-intl';
interface HotelInformationProps {
  checkInInformation: any;
  checkOutInformation: any;
  // checkOutInformation: BankDetails[];
  phone: any;
  pets: any;
  otherImportantInformation: string[];
  descriptions: string[];
}
const HotelInformation = ({
  checkInInformation,
  checkOutInformation,
  phone,
  pets,
  otherImportantInformation,
  descriptions,
}: HotelInformationProps) => {
  return (
    <div className="">
      <div className="card-header border-bottom bg-transparent px-0 pt-0">
        <h3 className="mb-0"><FormattedMessage id="hotel.information" /></h3>
      </div>
      <div className="card-body pt-4 px-md-0 px-3">
        {/* <div className="row">
          <div className="col-12">
            <ul className="list-group list-group-borderless mb-2">
              <li className="list-group-item d-flex">
                <i className="bi bi-info-circle-fill text-primary me-2"></i>
                Minimum age 21 and over required to check in. Free parking.
                There is a mandatory one-time 100.00 USD security deposit
                applied at check in by credit card, deposit amount will be
                released on departure, and it may take up to 5 business days to
                release.
              </li>
            </ul>
          </div>
        </div> */}
        <div className="row">
          <div className="col-md-6 col-12">
            <ul className="list-group list-group-borderless mb-2">
              <li className="list-group-item h6 fw-light d-flex mb-0">
                <i className="bi bi-calendar2-check text-primary me-2"></i>
                <b className="me-2"><FormattedMessage id="hotel.check.in" />:</b> {checkInInformation ? checkInInformation?.split(":")?.slice(1)?.join(":")?.trim()
 : null}
              </li>
              <li className="list-group-item h6 fw-light d-flex mb-0">
                <i className="bi bi-calendar2-x text-primary me-2"></i>
                <b className="me-2"><FormattedMessage id="hotel.check.out" />:</b> {checkOutInformation ? checkOutInformation : null}
              </li>
              <li className="list-group-item h6 fw-light d-flex mb-0">
                <i className="bi bi-telephone text-primary me-2"></i>
                <b className="me-2"><FormattedMessage id="lobby.phone" /></b> <a href="tel:4078159500">{phone ? phone : null}</a>
              </li>
              {/* <li className="list-group-item h6 fw-light d-flex mb-0">
                <i className="bi bi-printer text-primary me-2"></i>
                <b className="me-2">Fax:</b>{" "}
                <a href="tel:4078151999">(407) 815-1999</a>
              </li> */}
            </ul>
          </div>
          <div className="col-md-6 col-12">
            <ul className="list-group list-group-borderless mb-2">
              {/* <li className="list-group-item h6 fw-light d-flex mb-0">
                <i className="bi bi-clock text-primary me-2"></i>
                <b className="me-2">Lobby hours:</b> 24/7
              </li> */}
              {/* <li className="list-group-item h6 fw-light d-flex mb-0">
                <i className="bi bi-sun text-primary me-2"></i>
                <b className="me-2">Breakfast:</b> 6:00 am - 10:00 am
              </li> */}
              {/* <li className="list-group-item h6 fw-light d-flex mb-0">
                <i className="bi bi-x-circle-fill text-danger me-2"></i>
                <b className="me-2">Smoking:</b> Smoke-free
              </li> */}
              {pets.length > 0 && (
                <li className="list-group-item h6 fw-light d-flex mb-0">
                  <i className="bi bi-x-circle-fill text-danger me-2"></i>
                  <b className="me-2"><FormattedMessage id="pets" />:</b> {pets.map((pet) => pet.name)}
                </li>
              )}
            </ul>
          </div>
          <div className="row">
            <div className="col-12">
              {otherImportantInformation.length > 0 && (
                <ul className="list-group hotelInfo">
                  {otherImportantInformation.map((data, index) => (
                    <li key={index} className="list-group-item h6 fw-light d-flex mb-0">
                      <i className="bi bi-info-circle-fill text-primary me-2"></i>
                      <span dangerouslySetInnerHTML={{ __html: data }}></span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              {descriptions.length > 0 && (
                <div className="card border ">
                  <div className="card-body p-3">
                    <h5 className="mb-3 text-primary"><FormattedMessage id="hotel.description" /></h5>
                    <ul className="list-group list-group-flush">
                      {descriptions.map((data, index) => (
                        <li
                          key={index}
                          className="list-group-item d-flex align-items-start border-0 pb-0 ps-0"
                        >
                          <i className="bi bi-info-circle-fill text-primary me-2"></i>
                          <span dangerouslySetInnerHTML={{ __html: data }}></span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelInformation;
